import P from '../pages';
import FormHeader from './FormHeader';
import Alert from './Alert';
import ReactMarkdown from 'react-markdown';
import { defaultMessages } from '../../../libs/i18n/default';
import FormControl from 'react-bootstrap/lib/FormControl';
import ControlLabel from 'react-bootstrap/lib/ControlLabel';
import ReactHtmlParser from 'react-html-parser';
import { CustomFormGroup, Form, FormDate } from '../../../shared/components';
import React, { useState, useEffect, useRef } from 'react';
import { arrivalObj, pickupObj } from '../helpers'
import { useSelector } from 'react-redux';
import { pageValid, fieldsToValidate, validator, arrivalPickupValidation } from '../../../shared/validator';
import { arrivalSubmit } from '../actions';
import withDefaults from './withDefaults'
import InlineButton from './InlineButton';
import { changeState, formatDate, optionsFromArray } from '../../../shared/utilities';
import { setProfileElementsFromState } from '../../../shared/profileElementHelpers';
import { get } from 'lodash';

const Arrival = ({ content, dispatch, page, user, territory, intl: { formatMessage } }) => {
  const thisPage = P.ARRIVAL_PAGE;
  const [submitted, setSubmitted] = useState(false)
  const [timers, setTimers] = useState([])
  const { pickup: gP, arrival: gA } = user.guest
  const flightBooking = gA.arrival_filename
  const [newUpload, setNewUpload] = useState(!gA.arrival_filename)
  const delayedValidation = ['arrivalPlaceName']
  const timeOptions = useSelector(state => state.arrival_times)
  const contactTypes = ['Taxi', 'PublicTransport', 'FriendRelative', 'Rideshare', 'Other'].map(contactType => {
    let translationKey = 'clientGuestPagesArrivalSelectContactType'
    let key = translationKey + 'Keys' + contactType
    let value = translationKey + 'Values' + contactType

    return [defaultMessages[key].defaultMessage, defaultMessages[value].defaultMessage]
  })
  const transportTypeVal = () => {
    if (gP.transport_type) { return gP.transport_type }
    const apuRequired = setProfileElementsFromState('', 'placement', 'airport_pickup_required')
    if (apuRequired) { return apuRequired == 'Yes' ? 'transport_company' : 'other' }
    if (user.guest.type.code == 'high-school-student') { return 'transport_company' }
    return ''
  }
  const currentlyOnshore = useSelector(state => state.onshore)
  const [fields, setFields] = useState({
    pickupPlaceId: pickupObj(gP, 'place_id'),
    pickupPlaceName: pickupObj(gP, 'place_name'),
    pickupPickupTime: pickupObj(gP, 'pickup_time'),
    pickupDate: {
      ...pickupObj(gP, 'date'),
      errors: {
        greaterThanMaximum: formatMessage(defaultMessages.clientGuestPagesArrivalPopoversFutureDate)
      }
    },
    pickupTime: pickupObj(gP, 'time'),
    pickupTransportType: {
      ...pickupObj(gP, 'transport_type'),
      val: transportTypeVal()
    },
    pickupContactType: {
      ...pickupObj(gP, 'contact_type'),
      dependentObj: 'pickupTransportType',
      dependencyMet: (dependentObj = fieldsRef.current.pickupTransportType) => (dependentObj.val == 'other')
    },
    pickupContactName: {
      ...pickupObj(gP, 'contact_name'),
      dependentObj: 'pickupTransportType',
      dependencyMet: (dependentObj = fieldsRef.current.pickupTransportType) => (dependentObj.val == 'other')
    },
    pickupContactPhone: {
      ...pickupObj(gP, 'contact_phone'),
      dependentObj: 'pickupTransportType',
      dependencyMet: (dependentObj = fieldsRef.current.pickupTransportType) => (dependentObj.val == 'other')
    },
    pickupId: pickupObj(gP, 'id'),
    arrivalDate: {
      ...arrivalObj(gA, 'date'),
      errors: {
        afterMaxDate: formatMessage(defaultMessages.clientGuestPagesArrivalPopoversMaxDate),
        greaterThanMaximum: formatMessage(defaultMessages.clientGuestPagesArrivalPopoversFutureDate)
      }
    },
    pickupNotes: pickupObj(gP, 'notes'),
    arrivalTime: arrivalObj(gA, 'time'),
    arrivalNotes: arrivalObj(gA, 'notes'),
    arrivalVesselNo: arrivalObj(gA, 'vessel_no'),
    arrivalId: arrivalObj(gA, 'id'),
    arrivalPlaceId: arrivalObj(gA, 'place_id'),
    arrivalPlaceName: arrivalObj(gA, 'place_name'),
    onshore: { val: currentlyOnshore == null ? '' : (currentlyOnshore ? 'Yes' : 'No') },
    arrivalFlightBooking: { val: '' }
  })
  const skipValidations = ['arrival_place_name', 'arrival_time', 'arrival_date']
  const overwriteValidations = ['arrivalDate', 'arrivalTime', 'pickupDate', 'pickupTime']
  const [arrivalPlace, setArrivalPlace] = useState(fields.arrivalPlaceName.val)
  const [pickupPlace, setPickupPlace] = useState(fields.pickupPlaceName.val)
  const debounceTimeout = useRef(null)
  const fieldsRef = useRef(fields)
  fieldsRef.current = fields

  const handleArrivalChange = (key, val) => {
    let timeout = delayedValidation.includes(key) && val ? 700 : 0
    let obj = fields[key]
    let skip = fields.onshore.val == 'Yes' && skipValidations.includes(obj.validationKey)
    clearTimeout(timers[key])
    if (delayedValidation.includes(key)) {
      setFields(prevFields => ({...prevFields, [key]: {...obj, valid: null }}))
    }
    let timer = setTimeout(async() => {
      let result = null
      if (overwriteValidations.includes(key)) {
        let transportDateTimeFields = {
          arrivalDate: fields.arrivalDate,
          pickupDate: fields.pickupDate,
          arrivalTime: fields.arrivalTime,
          pickupTime: fields.pickupTime
        }
        const { [key]: _, ...newTransportDateTimeFields } = transportDateTimeFields;
        result = await validator(val, obj.validationKey, newTransportDateTimeFields)
      } else {
        result = await validator(val, obj.validationKey)
      }
      const linkedFields = get(result, 'linkedFields')
      obj.valid = skip ? true : get(result, 'valid')
      obj.failedValidation = get(result, 'failedValidation')
      obj.val = val
      obj.loading = false

      if (linkedFields) {
        const linkedFieldsEntries = Object.entries(linkedFields)
        setFields(prevFields => ({
          ...prevFields,
          [key]: obj,
          [linkedFieldsEntries[0][0]]: linkedFieldsEntries[0][1],
          [linkedFieldsEntries[1][0]]: linkedFieldsEntries[1][1],
          [linkedFieldsEntries[2][0]]: linkedFieldsEntries[2][1]
        }))
      } else {
        setFields(prevFields => ({...prevFields, [key]: obj}))
      }
    }, timeout)
    setTimers({...timers, [key]: timer})
  }

  const changeFlightValidations = skipValidations => {
    setFields({
      ...fields,
      arrivalPlaceName: {
        ...fields.arrivalPlaceName,
        valid: skipValidations,
        val: ''
      },
      arrivalDate: {
        ...fields.arrivalDate,
        valid: skipValidations,
        val: ''
      },
      arrivalTime: {
        ...fields.arrivalTime,
        valid: skipValidations,
        val: ''
      }
    })
  }

  const autocompletePlace = (id, kind = '', isPickup = true) => {
    $(id).autocomplete({
      source: `/places/autocomplete${kind}`,
      minLength: 2,
      autoFocus: true,
      delay: 100,
      select: function(e,ui){
        e.preventDefault();
        $(id).blur();
        handlePlaceSearch(ui.item, isPickup)
      },
      focus: function(e,ui){
        e.preventDefault();
      }
    });
  }

  const handlePlace = (key, val) => {
    if ( key == 'pickupPlaceName') {
      setPickupPlace(val)
    } else {
      setArrivalPlace(val)
    }

    if (debounceTimeout.current) {
      clearTimeout(debounceTimeout.current);
    }

    debounceTimeout.current = setTimeout(() => {
      handleArrivalChange(key, val);
    }, 500);
  };


  useEffect(() => {
    autocompletePlace('#arrivalPlaceName', '?kind=airport, bus_terminal', false)
    autocompletePlace('#pickupPlaceName')

    fieldsToValidate(fields).forEach(async(f) => {
      handleArrivalChange(f, fields[f].val, false)
    })

    changeFlightValidations(fields.onshore.val == 'Yes' ? true : null)
  }, [])

  useEffect(() => {
    changeFlightValidations(fields.onshore.val == 'Yes' ? true : null)
    fields.onshore.val == 'Yes' ? autocompletePlace('#pickupPlaceName') : autocompletePlace('#arrivalPlaceName', '?kind=airport, bus_terminal', false)
  }, [fields.onshore])

  const handlePlaceSearch = async ({ label: name, value: id, query}, forPickup = false) => {
    handlePlace(forPickup ? 'pickupPlaceName' : 'arrivalPlaceName', id == -1 ? query : name)
    handleArrivalChange(forPickup ? 'pickupPlaceId' : 'arrivalPlaceId', id == -1 ? '' : id)
  }

  const submit = (e) => {
    e.preventDefault()
    setSubmitted(true)
    dispatch(arrivalSubmit({...fields}))
  }

  return (
    <Form page={page} thisPage={thisPage} back={true} skip={true} submitFunc={submit} disableSubmit={!pageValid(fields) || submitted} >
      <FormHeader title={content.pages.arrival.title} />
      <ReactMarkdown source={content.pages.arrival.required_fields}/>
      <div className="row">
        <CustomFormGroup field={fields.onshore}>
          <ControlLabel htmlFor="onshore">{formatMessage(defaultMessages.clientGuestPagesArrivalLabelsOnshore)}</ControlLabel>
          <FormControl
            id="onshore"
            type="select"
            componentClass="select"
            placeholder={formatMessage(defaultMessages.clientCommonSelectsSelect)}
            defaultValue={fields.onshore.val}
            onChange={e => setFields({...fieldsRef.current, onshore: { val: e.target.value }})}>
            <option value="select" key="select">{formatMessage(defaultMessages.clientCommonYesNo)}</option>
            <option value="Yes" key="Yes">{formatMessage(defaultMessages.clientCommonAffirmative)}</option>
            <option value="No" key="No">{formatMessage(defaultMessages.clientCommonNegative)}</option>
          </FormControl>
        </CustomFormGroup>

        {fields.onshore.val != 'Yes' && (
          <div className="col-md-6">
            <h5 style={{margin: 'auto'}}>{content.pages.arrival.arrival}</h5>
            <hr/>
            <CustomFormGroup field={fields.arrivalPlaceName}>
              <ControlLabel htmlFor="arrivalPlaceName">{formatMessage(defaultMessages.clientGuestPagesArrivalLabelsAirport)}</ControlLabel>
              <FormControl
                id="arrivalPlaceName"
                type="text"
                placeholder={formatMessage(defaultMessages.clientCommonSelectsSearch)}
                value={arrivalPlace}
                onChange={e => handlePlace('arrivalPlaceName', e.target.value)} />
            </CustomFormGroup>

            <CustomFormGroup field={fields.arrivalVesselNo}>
              <ControlLabel htmlFor="arrivalVesselNo">{formatMessage(defaultMessages.clientGuestPagesArrivalLabelsVessel)}</ControlLabel>
              <FormControl
                id="arrivalVesselNo"
                type="text"
                defaultValue={fields.arrivalVesselNo.val}
                onChange={e => handleArrivalChange('arrivalVesselNo', e.target.value)} />
            </CustomFormGroup>

            <CustomFormGroup field={fields.arrivalDate}>
              <ControlLabel htmlFor="arrivalDate_day">{formatMessage(defaultMessages.clientGuestPagesArrivalLabelsArrivalDate)}</ControlLabel>
              <FormDate
                setDate={date => handleArrivalChange('arrivalDate', date)}
                formDateId={'arrivalDate'}
                date={formatDate(fields.arrivalDate.val)} />
            </CustomFormGroup>

            <CustomFormGroup field={fields.arrivalTime}>
              <ControlLabel htmlFor="arrivalTime">{formatMessage(defaultMessages.clientGuestPagesArrivalLabelsArrivalTime)}</ControlLabel>
              <FormControl
                id="arrivalTime"
                type="select"
                componentClass="select"
                placeholder={formatMessage(defaultMessages.clientCommonSelectsSelect)}
                defaultValue={fields.arrivalTime.val}
                onChange={e => handleArrivalChange('arrivalTime', e.target.value)}>
                {optionsFromArray(timeOptions, formatMessage, 'arrival')}
              </FormControl>
            </CustomFormGroup>

            <CustomFormGroup field={fields.arrivalNotes}>
              <ControlLabel htmlFor="arrivalNotes">{formatMessage(defaultMessages.clientGuestPagesArrivalLabelsArrivalNotes)}</ControlLabel>
              <FormControl
                id="arrivalNotes"
                type="text"
                componentClass="textarea"
                defaultValue={fields.arrivalNotes.val}
                onChange={e => handleArrivalChange('arrivalNotes', e.target.value)} />
            </CustomFormGroup>
            <div className="form-group">
              {flightBooking && (
                <p>
                  {ReactHtmlParser(formatMessage(
                    defaultMessages.clientGuestPagesArrivalLabelsFileUploaded,
                    {name: flightBooking, kind: 'arrival'}
                  ))}
                  {' '}
                  <InlineButton type="button" onClick={() => setNewUpload(true)}>
                    {formatMessage(defaultMessages.clientGuestPagesArrivalLabelsReupload)}
                  </InlineButton>
                  {' '}
                  {formatMessage(defaultMessages.clientGuestPagesArrivalLabelsReuploadSuffix)}
                </p>
              )}
              {newUpload && (
                <>
                  <ControlLabel> {formatMessage(defaultMessages.clientGuestPagesArrivalLabelsUploadFile)} </ControlLabel>
                  <FormControl
                    id="file"
                    type="file"
                    componentClass="input"
                    onChange={e => setFields({...fieldsRef.current, arrivalFlightBooking: { val: e.target.files[0] }})}
                  />
                </>
              )}
            </div>
          </div>
        )}

        <div className="col-md-6">
          <h5 style={{margin: 'auto'}}>{content.pages.arrival.pickup}</h5>
          <hr/>

          <CustomFormGroup field={fields.pickupTransportType}>
            <ControlLabel htmlFor="pickupTransportType">{formatMessage(defaultMessages.clientGuestPagesArrivalLabelsRequirePickup)}</ControlLabel>
            <FormControl
              id="pickupTransportType"
              type="select"
              componentClass="select"
              placeholder={formatMessage(defaultMessages.clientCommonSelectsSelect)}
              defaultValue={content.territory_code == "asc" ? "transport_company" : fields.pickupTransportType.val}
              onChange={e => handleArrivalChange('pickupTransportType', e.target.value)}
              disabled={content.territory_code == "asc"}>
              <option value="" key="select">{formatMessage(defaultMessages.clientCommonSelectsSelect)}</option>
              <option value="transport_company" key="Yes">{formatMessage(defaultMessages.clientCommonAffirmative)}</option>
              <option value="other" key="No">{formatMessage(defaultMessages.clientCommonNegative)}</option>
            </FormControl>
          </CustomFormGroup>

          {fields.onshore.val == 'Yes' && (
            <div>
              <CustomFormGroup field={fields.pickupPlaceName}>
                <ControlLabel htmlFor="pickupPlaceName">{formatMessage(defaultMessages.clientGuestPagesArrivalLabelsPickupLocation)}</ControlLabel>
                <FormControl
                  id="pickupPlaceName"
                  type="text"
                  placeholder={formatMessage(defaultMessages.clientCommonSelectsSearch)}
                  value={pickupPlace}
                  onChange={e => handlePlace('pickupPlaceName', e.target.value)} />
              </CustomFormGroup>
              <CustomFormGroup field={fields.pickupPickupTime}>
                <ControlLabel htmlFor="pickupPickupTime">{formatMessage(defaultMessages.clientGuestPagesArrivalLabelsAnticipatedPickupTime)}</ControlLabel>
                <FormControl
                  id="pickupPickupTime"
                  type="select"
                  componentClass="select"
                  placeholder={formatMessage(defaultMessages.clientCommonSelectsSelect)}
                  defaultValue={fields.pickupPickupTime.val}
                  onChange={e => handleArrivalChange('pickupPickupTime', e.target.value)}>
                  {optionsFromArray(timeOptions, formatMessage, 'pickup')}
                </FormControl>
              </CustomFormGroup>
            </div>
          )}

          {fields.pickupTransportType.val == "other" &&
            <div>
              <ControlLabel>{formatMessage(defaultMessages.clientGuestPagesArrivalLabelsHow)}</ControlLabel>
              <CustomFormGroup field={fields.pickupContactType}>
                <FormControl
                  id="pickupContactType"
                  type="select"
                  componentClass="select"
                  placeholder={formatMessage(defaultMessages.clientCommonSelectsSelect)}
                  defaultValue={fields.pickupContactType.val}
                  onChange={e => handleArrivalChange('pickupContactType', e.target.value)}>
                  {optionsFromArray(contactTypes, formatMessage)}
                </FormControl>
              </CustomFormGroup>

              <CustomFormGroup field={fields.pickupContactName}>
                <FormControl
                  id="pickupContactName"
                  type="text"
                  componentClass="input"
                  placeholder={formatMessage(defaultMessages.clientGuestPagesArrivalPlaceholdersContactName)}
                  defaultValue={fields.pickupContactName.val}
                  onChange={e => handleArrivalChange('pickupContactName', e.target.value)} />
              </CustomFormGroup>

              <CustomFormGroup field={fields.pickupContactPhone}>
                <FormControl
                  id="pickupContactPhone"
                  type="text"
                  componentClass="input"
                  placeholder={formatMessage(defaultMessages.clientGuestPagesArrivalPlaceholdersContactPhone)}
                  defaultValue={fields.pickupContactPhone.val}
                  onChange={e => handleArrivalChange('pickupContactPhone', e.target.value)} />
              </CustomFormGroup>
            </div>
          }


          <CustomFormGroup field={fields.pickupDate}>
            <ControlLabel htmlFor="pickupDate_day">{formatMessage(defaultMessages.clientGuestPagesArrivalLabelsPickupDate)}</ControlLabel>
            <FormDate
              setDate={date => handleArrivalChange('pickupDate', date)}
              formDateId={'pickupDate'}
              date={formatDate(fields.pickupDate.val)} />
          </CustomFormGroup>

          <CustomFormGroup field={fields.pickupTime}>
            <ControlLabel htmlFor="pickupTime">{formatMessage(defaultMessages.clientGuestPagesArrivalLabelsPickupTime)}</ControlLabel>
            <FormControl
              id="pickupTime"
              type="select"
              componentClass="select"
              placeholder={formatMessage(defaultMessages.clientCommonSelectsSelect)}
              defaultValue={fields.pickupTime.val}
              onChange={e => handleArrivalChange('pickupTime', e.target.value)}>
              {optionsFromArray(timeOptions, formatMessage, 'pickup')}
            </FormControl>
          </CustomFormGroup>
          <CustomFormGroup field={fields.pickupNotes}>
            <ControlLabel htmlFor="pickupNotes">{formatMessage(defaultMessages.clientGuestPagesArrivalLabelsPickupNotes)}</ControlLabel>
            <FormControl
              id="pickupNotes"
              type="text"
              componentClass="textarea"
              defaultValue={fields.pickupNotes.val}
              onChange={e => handleArrivalChange('pickupNotes', e.target.value)} />
          </CustomFormGroup>
        </div>
      </div>
      <Alert alert={content.pages.arrival.info}/>
    </Form>
  )
}

export default withDefaults(Arrival);
